import { MappableModel } from './mappable-model'

export class Cart extends MappableModel {
  public sale_number: number
  public sale_group_number: number
  public placed_successfully: boolean
}
